<template>
  <PageBase
    show-top-bar
    background-color="bg-white"
    title="Masukkan Ulang PIN"
    :top-bar-white="true"
  >
    <div class="p-4 pt-8">
      <p class="mid-text-subtitle-1 font-normal text-black-500">
        Masukkan kembali PIN 6 digit yang telah anda buat untuk konfirmasi
      </p>
    </div>
    <div class="p-4 pt-8">
      <el-form
        label-position="top"
        :model="form"
        :rules="rules"
        hide-required-asterisk
        validate-on-rule-change
        ref="ruleFormRef"
      >
        <el-form-item label="" prop="pin">
          <div class="flex gap-x-3 justify-center w-full">
            <div class="mx-auto flex gap-x-3">
              <input
                v-for="(_, index) in pinLength"
                :key="index"
                :ref="(el) => setInputRef(el as HTMLInputElement | null, index)"
                v-model="pin[index]"
                type="password"
                inputmode="numeric"
                maxlength="1"
                @input="onInput($event, index)"
                @keydown="onKeydown($event, index)"
                :class="[
                  'w-[48px] h-[62px] text-[64px] border rounded-sm appearance-none focus:outline-none leading-none text-center grid place-items-center',
                  errorState.pinNotMatch
                    ? 'text-[#de1035] border-[#de1035]'
                    : 'text-[#00A6f4] border-[#e8e8e9]'
                ]"
                autocomplete="off"
              />
            </div>
          </div>
          <div v-if="errorState.pinNotMatch" class="w-full flex justify-center">
            <span class="text-[#de1035] text-center mt-2 text-base font-normal">
              PIN tidak cocok, silahkan coba lagi
            </span>
          </div>
        </el-form-item>
        <div>
          <el-button
            class="w-full mt-10"
            :type="pin.join('').length !== 6 ? 'info' : 'primary'"
            :loading="loading.form"
            @click="handleSubmit(ruleFormRef)"
            :disabled="pin.join('').length !== 6"
            >LANJUT</el-button
          >
        </div>
      </el-form>
    </div>
  </PageBase>
</template>

<script setup lang="ts">
import { useCreateAgainPinForm } from './composables/useCreateAgainPinForm'

const {
  form,
  rules,
  ruleFormRef,
  loading,
  pinLength,
  pin,
  setInputRef,
  errorState,
  onInput,
  onKeydown,
  handleSubmit
} = useCreateAgainPinForm()
</script>
